import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import { setModal } from "../../redux/rightModalSlice";
import moment from "moment";

export default function ProductMovementLine({ movementData, index }) {
    const dispatch = useDispatch();
    
    // Gestisce il click sul bottone di visualizzazione
    const handleViewClick = (e) => {
        e.stopPropagation();
        dispatch(setModal({
            mode: 'view',
            id: movementData._id
        }));
    };
    
    // Gestisce il click sull'intera riga
    const handleRowClick = () => {
        dispatch(setModal({
            mode: 'view',
            id: movementData._id
        }));
    };

    // Formatta il prezzo
    const formatPrice = (price) => {
        if (price === undefined || price === null) return "--";
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(price);
    };

    // Formatta la data
    const formatDate = (date) => {
        if (!date) return "--";
        return moment(date).format('DD/MM/YYYY');
    };

    // Ottiene la classe di stile in base al tipo di movimento
    const getMovementTypeClass = (type) => {
        if (!type) return "";
        
        switch (type.toLowerCase()) {
            case 'entrata':
            case 'ingresso':
            case 'acquisto':
                return 'text-green-600';
            case 'uscita':
            case 'vendita':
                return 'text-red-600';
            case 'trasferimento':
                return 'text-blue-600';
            case 'reso':
                return 'text-orange-600';
            default:
                return '';
        }
    };
    
    return (
        <div 
            className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} w-full flex justify-between cursor-pointer hover:bg-gray-100 rounded-lg`}
            onClick={handleRowClick}
        >
            {/* Data Movimento */}
            <div className="px-6 py-4 w-1/6 truncate">
                {formatDate(movementData.movementDate)}
            </div>
            
            {/* Prodotto */}
            <div className="px-6 py-4 w-1/5 truncate">
                <div className="font-semibold">{movementData.productCode || "--"}</div>
                {movementData.productLabel && (
                    <div className="text-xs text-gray-500">{movementData.productLabel}</div>
                )}
            </div>
            
            {/* Tipo Movimento */}
            <div className={`px-6 py-4 w-1/6 truncate font-semibold ${getMovementTypeClass(movementData.movementType)}`}>
                {movementData.movementType || "--"}
            </div>
            
            {/* Quantità */}
            <div className="px-6 py-4 w-1/6 truncate text-right">
                {movementData.quantity || "--"}
            </div>
            
            {/* Prezzo */}
            <div className="px-6 py-4 w-1/6 truncate text-right">
                {formatPrice(movementData.purchasePrice)}
            </div>
            
            {/* Bottoni Azioni */}
            <div className="px-6 py-4 w-1/6 flex justify-end items-center space-x-2">
                <button 
                    className="p-1 hover:bg-blue-100 rounded-full"
                    onClick={handleViewClick}
                    title="Visualizza"
                >
                    <DynamicIcon iconClass="fa-solid fa-eye" />
                </button>
            </div>
        </div>
    );
}
